import { Icon } from '@ligr/shared';
import React from 'react';
import { useHistory } from 'react-router';
import { ConfirmWindow } from '../../../../components/ConfirmWindow';
import { ConfirmWindowCompetitionContent } from '../../../../components/ConfirmWindow/Content/CompetitionContent';
import { ContextMenu } from '../../../../components/ContextMenu';
import { Notification } from '../../../../lib/notificationContainer';
import { useArchiveCompetition } from '../../../../lib/useArchiveCompetition';
import { routes } from '../../../../router/Routes';

interface CompetitionMenuProps {
  competition: {
    id: number;
    name: string;
    countTeams: number;
    countMatches: number;
  };
}

export const CompetitionMenu: React.FunctionComponent<CompetitionMenuProps> = ({ competition }) => {
  const { archiveCompetition } = useArchiveCompetition();
  const { addNotification } = Notification.useContainer();
  const history = useHistory<{ referrer?: string } | undefined>();

  const archiveCompetitionFn = async (competitionId: number) => {
    await archiveCompetition(competitionId);
    addNotification('Competition archived successfully.', 'success');
    history.push(routes.assetsCompetitions());
  };

  return (
    <ContextMenu
      place="bottom"
      clickable={true}
      className="pageHeader__menu competitionMenu"
      renderMenu={() => {
        return (
          <ul>
            <li>
              <ConfirmWindow
                action={() => archiveCompetitionFn(competition.id)}
                title={`Archive competiton`}
                content={<ConfirmWindowCompetitionContent competition={competition} />}
              >
                <Icon icon="close" />
                <span>Archive competition</span>
              </ConfirmWindow>
            </li>
          </ul>
        );
      }}
    >
      <Icon icon="dropdown" color="grey-600" />
    </ContextMenu>
  );
};
